import React from "react";

// Brand-accurate WhatsApp glyph
export default function WhatsAppIcon({ size = 20, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-label="WhatsApp"
    >
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.493-.487 2.965-1.345.143-.27.27-.566.27-.866 0-.516-.272-.6-.572-.6h-.65zM16.005 1.5C7.997 1.5 1.5 7.997 1.5 16c0 2.836.84 5.475 2.265 7.7L2.5 30.5l6.95-1.245A14.355 14.355 0 0 0 16.005 30.5c8.008 0 14.505-6.497 14.505-14.5S24.013 1.5 16.005 1.5zm0 26.55a12 12 0 0 1-6.5-1.91l-.46-.3-4.135.74.74-4.07-.3-.47A12.04 12.04 0 0 1 3.95 16c0-6.642 5.41-12.05 12.055-12.05S28.06 9.358 28.06 16c0 6.642-5.41 12.05-12.055 12.05z" />
    </svg>
  );
}
